<template>
  <div>
    <content-loader
      :height="250"
      :width="700"
      :speed="2"
      :animate="true"
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
      v-for="(content, index) in (1, data.count)"
      :key="index">
      <circle cx="15" cy="30" r="10" />
      <rect x="15" y="40" rx="4" ry="4" width="1" height="250" />

      <rect x="40" y="20" rx="0" ry="0" width="200" height="100" />

      <rect x="265" y="20" rx="3" ry="3" width="60" height="15" />

      <rect x="265" y="40" rx="3" ry="3" width="200" height="17.02" />

      <rect x="265" y="65" rx="3" ry="3" width="110" height="8.17" />
      <rect x="385" y="65" rx="3" ry="3" width="50" height="8.17" />

      <rect x="265" y="85" rx="3" ry="3" width="350" height="5" />
      <rect x="265" y="95" rx="3" ry="3" width="380" height="5" />
      <rect x="265" y="105" rx="3" ry="3" width="380" height="5" />
      <rect x="265" y="115" rx="3" ry="3" width="350" height="5" />
      <rect x="265" y="125" rx="3" ry="3" width="201" height="5" />

      <circle cx="670" cy="30" r="10" />

      <rect x="620" y="220" rx="3" ry="3" width="60" height="15" />
      <rect x="545" y="220" rx="3" ry="3" width="60" height="15" />
      <rect x="470" y="220" rx="3" ry="3" width="60" height="15" />

      <rect x="0" y="249" rx="3" ry="3" width="700" height="1" />
    </content-loader>
  </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
  name: 'CLItineraryDay',
  components: { ContentLoader },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
</style>
